const userPanelHelp = [
  {
    id: 1,
    text: "در این صفحه (بدن من) شما می توانید اطلاعات بدنی خود را بررسی کنید",
  },
  {
    id: 2,
    text: "با زدن روی این آیکون شما می توانید بازخورد هر جلسه و همچنین گزارش هر ماه مورد نیاز را برای مربی خود ارسال کنید",
  },
  {
    id: 3,
    text: "امتیاز های کنار عکس پروفایل شما مربوط به درصد انجام چالش ها و تعداد ماه هایی است که در کلاس ها شرکت کردید، که مجموع این امتیازات در کادر زرد رنگ به صورت امتیاز کلی و لول شما جهت اهدای سکه در نظر گرفته شده",
  },
  {
    id: 4,
    text: "همچنین زمان برگزاری کلاس هایی که فقط مربوط به شماست در این صفحه قابل رویت است",
  },
];

export default userPanelHelp;
